
import * as handlebars_family from "../../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/part/cal_edit_icalui",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p class=\"text flexrow\"><flexauto style=\"word-break: break-all;text-align: left;\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icalurl") : depth0), depth0))
    + "</flexauto><icon class=\"color-branded\" data-fw-onclick=\"calicalrefresh\" style=\"font-size:34px;border-radius:50%;padding:4px;border:var(--border)\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_refresh",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":305},"end":{"line":1,"column":329}}}))
    + "</icon></p><button data-fw-onclick=\"copyprevchild\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.copylink",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":380},"end":{"line":1,"column":409}}})) != null ? stack1 : "")
    + "</button><button class=\"negative\" data-fw-onclick=\"calicaldelete\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.delete",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":475},"end":{"line":1,"column":502}}})) != null ? stack1 : "")
    + "</button> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button data-fw-onclick=\"calicalgenerate\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"calendars.icalgenerate",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":563},"end":{"line":1,"column":598}}})) != null ? stack1 : "")
    + "</button> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"calendars.icaltitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":7},"end":{"line":1,"column":39}}})) != null ? stack1 : "")
    + "</label> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icalurl") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":48},"end":{"line":1,"column":615}}})) != null ? stack1 : "")
    + " <p class=\"sub4\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"calendars.icaltext",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":632},"end":{"line":1,"column":663}}})) != null ? stack1 : "")
    + "</p> ";
},"useData":true});
export default TPL;